import React from "react";
/** Components Import */
import { FormCheck } from "react-bootstrap";

function Checkbox({
  className = "",
  title = "",
  disabled = false,
  value,
  onChange = (e) => {},
}) {
  const ChangeCheck = (e) => {
    onChange(e.target.checked);
  };

  return (
    <FormCheck
      id={`${title}`}
      className={className}
      type="checkbox"
      disabled={disabled}
      label={title}
      value={value}
      onChange={ChangeCheck}
    />
  );
}

export default Checkbox;
